import PropTypes from 'prop-types';
import './Badge.css';

export default function Badge({
    children,
    variant = 'default',
    size = 'md',
    dot = false,
    className = ''
}) {
    return (
        <span className={`badge badge-${variant} badge-${size} ${dot ? 'badge-dot' : ''} ${className}`}>
            {dot && <span className="badge-dot-indicator" />}
            {children}
        </span>
    );
}

Badge.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.oneOf(['default', 'primary', 'success', 'warning', 'danger', 'info']),
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    dot: PropTypes.bool,
    className: PropTypes.string
};
